<!-- pages/ChatPage.vue -->
<template>
  <title>Chat</title>
  <template>
    <favicon :href="faviconPath" />
  </template>

  <n-layout class="chat-layout" style="height: 100vh;">
    <!-- 头部（可选：标题、设置等） -->
    <!-- <n-layout-header>头部</n-layout-header> -->

    <!-- 聊天内容区：占据剩余空间，可滚动 -->
    <n-layout-content class="chat-content">
      <ChatWindow />
    </n-layout-content>

    <!-- 输入区：固定在底部 -->
    <n-layout-footer class="chat-footer" bordered>
      <ChatInput />
    </n-layout-footer>
  </n-layout>
</template>

<script setup>
import ChatWindow from '@/components/ChatWindow.vue'
import ChatInput from '@/components/ChatInput.vue'
import { NLayout, NLayoutContent, NLayoutFooter } from 'naive-ui'

</script>

<style scoped>
.chat-layout {
  display: flex;
  flex-direction: column;
}

.chat-content {
  flex: 80vh;                  /* 占据剩余所有空间 */
  overflow: hidden;         /* 重要：防止内容溢出 */
}

.chat-footer {
  padding: 16px 0;
  background: #ffffff; /* 使用白色背景，或根据主题调整 */
  border-top: 1px solid #eee !important; /* 使用标准颜色值 */
}

/* 如果需要支持暗色主题，可以使用媒体查询 */
@media (prefers-color-scheme: dark) {
  .chat-footer {
    background: #18181c;
    border-top: 1px solid #333 !important;
  }
}
</style>
